import React, { useEffect, useState } from 'react';
import { createUseStyles } from 'react-jss';
import PhoneInput from 'react-phone-number-input';
import 'react-phone-number-input/style.css';
import { useTranslation } from 'react-i18next';
import { layoutDefaults } from '../../utils/layout-defaults';

function MobileModalBody({
  defaultCountry,
  defaultPhoneNumber,
  onPhoneChange,
  disabled,
  labels,
}) {
  const classes = useStyles();
  const [phone, setPhone] = useState(defaultPhoneNumber);
  const { t } = useTranslation();

  useEffect(() => {
    onPhoneChange?.call(this, phone);
  }, [phone]);

  return (
    <div className={classes.container}>
      <PhoneInput
        placeholder={t('mobile-modal.placeholder')}
        limitMaxLength
        className="form-control"
        addInternationalOption={false}
        disabled={disabled}
        labels={labels}
        // readOnly
        // withCountryCallingCode={false}
        international={false}
        defaultCountry={defaultCountry}
        value={phone}
        onChange={setPhone}
      />
    </div>
  );
}

const useStyles = createUseStyles({
  container: {
    fontSize: layoutDefaults.fontSize,
    color: layoutDefaults.textColor,
    // display: 'flex',
    // flex: 1,
    // flexDirection: 'row',
    // flexDirection: 'column',
    // border: '1px solid red',
  },
});

export { MobileModalBody };
